<template>
    <label class="radio-button" :for="id" :class="[{ active }, { disabled }, { small }, { invalid: error }]">
        <input type="radio" :name="id" :id="id" :value="value" :disabled="disabled" @change="onChange"
            :checked="active" />
        <span class="text">
            <slot></slot>
        </span>
    </label>
</template>

<script>
export default {
    name: 'RadioButton',
    model: {
        prop: 'modelValue',
        event: 'input'
    },
    props: {
        id: String,
        value: {
            default: ''
        },
        disabled: Boolean,
        modelValue: {
            default: undefined
        },
        error: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.$emit('input', this.modelValue);
    },
    computed: {
        active() {
            return this.modelValue === this.value;
        }
    },
    methods: {
        onChange() {
            this.$emit('input', this.value);
            this.$emit('change', this.value);
        }
    }
};
</script>

<style lang="scss">
.radio-button {
    position: relative;
    width: 100%;
    height: 80px;
    background-color: #f7f7f7;
    border-radius: 4px;
    border: 2px solid transparent;

    >.text {
        line-height: 21px;
        position: absolute;
        text-align: center;
        padding: 0 15px;
        width: 100%;
        top: 50%;
        transform: translate(0, -50%);
    }

    >input {
        opacity: 0;
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        z-index: 50;
        cursor: pointer;

        &[type="radio"] {
            margin: 0;
        }
    }

    &:hover,
    &:focus {
        border-color: $brand-colour-primary;
    }

    &.active {
        border-color: $brand-colour-primary;
        background-color: $brand-colour-primary;
        color: #fff;
    }

    &.invalid {
        border-color: $form-border-colour--error;
    }

    &.disabled {
        opacity: 0.6;
        cursor: not-allowed;
        border-color: transparent;
    }

    &.small {
        .text {
            line-height: 15px;
            padding: 0 8px;
        }

        height: 44px;
    }

    &.radio-icons {
        height: 100px;

        &.active {
            background-color: transparent !important;
            color: inherit;
        }

        img {
            height: 60px;
        }

        font-size: 10px;
    }

    @media(max-width: 767px) {
        .text {
            line-height: 15px;
        }
    }
}
</style>
